export default (link) => {
  const regex = /https?:?\/?\/?/;
  if (!regex.test(link)) return `//${link}`;
  return link;
}